import React, { FC } from 'react';
import { TipWrapper, Field, RemoveTip } from './index.view';
import useViewModel from './viewModel';
import { usePlacingPayment } from 'contexts/placingPayment';

interface TipProps {
  amount?: number;
  center?: boolean;
}

const Tip: FC<TipProps> = ({ amount, center = false }) => {
  const { tipDescription, totalTip, totalTipPercent, isShowTip } = useViewModel({
    amount,
    center,
  });
  const { setTotalTipPercent, setIncludeTip, setSelected } = usePlacingPayment();

  const handleRemoveTip = () => {
    setTotalTipPercent(0);
    setIncludeTip(false);
    setSelected(undefined);
  };

  return isShowTip && totalTipPercent > 0 ? (
    <>
      <TipWrapper center={center}>
        <Field center={center}>{tipDescription}</Field>
        {!center && <Field>{`+${totalTip}`}</Field>}
      </TipWrapper>
      {!center && <RemoveTip onClick={handleRemoveTip}>Trinkgeld entfernen</RemoveTip>}
    </>
  ) : null;
};

export default Tip;
